import React, { useState } from 'react'
import styles from './style.module.css'
import Multiselect from 'multiselect-react-dropdown';
import { searchlocations } from '../../../action/databaseSearch';
const Index = ({ onSearch }) => {
    const [activeIndex, setActiveIndex] = useState(null);
    const toggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const [state, setState] = useState({
        include_keyword: { name: 'include_keyword', value: '' },
        city: { name: 'city', value: [], options: [] },
        salary: { name: 'salary', value: [] },
        age: { name: 'age', value: [] },
    });
    const setOptions = (name, newOptions) => {
        setState((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                options: newOptions,
            },
        }));
    };
    const onSubmit = () => {
        const model = {
            include_keyword: state.include_keyword.value,
            city: state.city.value,
            salary: state.salary.value,
            age: state.age.value
        }
        onSearch(model)
    };

    const handleSalaryCheckboxChange = (range) => {
        setState((prevState) => {
            const isSelected = prevState.salary.value.some(
                (item) => item[0] === range[0] && item[1] === range[1]
            );

            return {
                ...prevState,
                salary: {
                    ...prevState.salary,
                    value: isSelected
                        ? prevState.salary.value.filter(
                            (item) => !(item[0] === range[0] && item[1] === range[1])
                        )
                        : [...prevState.salary.value, range]
                }
            };
        });
    };

    const handleAgeCheckboxChange = (range) => {
        setState((prevState) => {
            const isSelected = prevState.age.value.some(
                (item) => item[0] === range[0] && item[1] === range[1]
            );

            return {
                ...prevState,
                age: {
                    ...prevState.age,
                    value: isSelected
                        ? prevState.age.value.filter(
                            (item) => !(item[0] === range[0] && item[1] === range[1])
                        )
                        : [...prevState.age.value, range]
                }
            };
        });
    };

    return (
        <React.Fragment>
            <div className={`${styles['order-second']} col-md-3`}>
                <div className={`${styles['ct-filterbox']} card`}>
                    <div className="card-body">
                        <div className={`${styles['job-filter']} mb-3 d-flex justify-content-between align-items-center`}>
                            <h6>Filter By</h6>
                            <a href='#'>Applied <sapn>(4)</sapn></a>
                        </div>
                        {/* <div className="form-group mb-2">
                            <div>
                                <div className={`${styles['accordion-ctm']} accordion`} id="accordionExample">
                                    <div className={`${styles['accordionitem-ctm']} accordion-item`}>
                                        <h2 className={`${styles['accordionheader-ctm']} accordion-header`} id="headingOne">
                                            <button className={`${styles['accordionbutton-ctm']} accordion-button ${activeIndex === 0 ? '' : 'collapsed'}`} type="button" onClick={() => toggle(0)}>
                                                Hide Candidates that
                                            </button>
                                        </h2>
                                        <div className={`${styles['accordioncollapse-ctm']} accordion-collapse ${activeIndex === 0 ? 'show' : ''}`} aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                            <div className={`${styles['accordionbody-ctm']} accordion-body`}>
                                                <div className={`${styles['formcheck-ctm']} form-check mb-1 d-flex align-items-center`}>
                                                    <input className="form-check-input" type="checkbox" id="formCheck1" />
                                                    <label className={`${styles['formcheckct-label']} form-check-label ps-2`} htmlFor="formCheck1">
                                                        Already unlocked
                                                    </label>
                                                </div>
                                                <div className={`${styles['formcheck-ctm']} form-check d-flex align-items-center`}>
                                                    <input className="form-check-input" type="checkbox" id="formCheck2" defaultChecked />
                                                    <label className={`${styles['formcheckct-label']} form-check-label ps-2`} htmlFor="formCheck2">
                                                        Downloaded in excel
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="form-group mb-2">
                            <div className={`${styles['accordion-ctm']} accordion`} id="accordionTwoExample">
                                <div className={`${styles['accordionitem-ctm']} accordion-item`}>
                                    <h2 className={`${styles['accordionheader-ctm']} accordion-header`} id="headingTwo">
                                        <button className={`${styles['accordionbutton-ctm']} accordion-button ${activeIndex === 1 ? '' : 'collapsed'}`} type="button" onClick={() => toggle(1)}>
                                            Show candidates
                                        </button>
                                    </h2>
                                    <div className={`${styles['accordioncollapse-ctm']} accordion-collapse ${activeIndex === 1 ? 'show' : ''}`} aria-labelledby="headingTwo" data-bs-parent="#accordionTwoExample">
                                        <div className={`${styles['accordionbody-ctm']} accordion-body`}>
                                            <div className={`${styles['formcheck-ctm']} form-check mb-1 d-flex align-items-center`}>
                                                <input className="form-check-input" type="checkbox" id="formCheck1" />
                                                <label className={`${styles['formcheckct-label']} form-check-label ps-2`} htmlFor="formCheck1">
                                                    Who have CV attached
                                                </label>
                                            </div>
                                            <div className={`${styles['formcheck-ctm']} form-check d-flex align-items-center`}>
                                                <input className="form-check-input" type="checkbox" id="formCheck2" defaultChecked />
                                                <label className={`${styles['formcheckct-label']} form-check-label ps-2`} htmlFor="formCheck2">
                                                    Downloaded in excel
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="form-group mb-2">
                            <div className={`${styles['accordion-ctm']} accordion`} id="accordionThreeExample">
                                <div className={`${styles['accordionitem-ctm']} accordion-item`}>
                                    <h2 className={`${styles['accordionheader-ctm']} accordion-header`} id="headingThree">
                                        <button className={`${styles['accordionbutton-ctm']} accordion-button ${activeIndex === 2 ? '' : 'collapsed'}`} type="button" onClick={() => toggle(2)}>
                                            Must have keyword
                                        </button>
                                    </h2>
                                    <div className={`${styles['accordioncollapse-ctm']} accordion-collapse ${activeIndex === 2 ? 'show' : ''}`} aria-labelledby="headingThree" data-bs-parent="#accordionThreeExample">
                                        <div className={`${styles['accordionbody-ctm']} accordion-body`}>
                                            <input type="text" className="form-control" placeholder="Enter keywords to include"
                                                name={state.include_keyword.name}
                                                value={state.include_keyword.value}
                                                onChange={(e) => {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        ['include_keyword']: {
                                                            ...prevState['include_keyword'],
                                                            value: e.target.value
                                                        },
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="form-group mb-2">
                            <div className={`${styles['accordion-ctm']} accordion`} id="accordionFourExample">
                                <div className={`${styles['accordionitem-ctm']} accordion-item`}>
                                    <h2 className={`${styles['accordionheader-ctm']} accordion-header`} id="headingFour">
                                        <button className={`${styles['accordionbutton-ctm']} accordion-button ${activeIndex === 3 ? '' : 'collapsed'}`} type="button" onClick={() => toggle(3)}>
                                            Exclude keywords
                                        </button>
                                    </h2>
                                    <div className={`${styles['accordioncollapse-ctm']} accordion-collapse ${activeIndex === 3 ? 'show' : ''}`} aria-labelledby="headingFour" data-bs-parent="#accordionFourExample">
                                        <div className={`${styles['accordionbody-ctm']} accordion-body`}>
                                            <input type="text" className={`${styles['forminput-control']} form-control`} placeholder="Enter keywords to exclude" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="form-group mb-2">
                            <div className={`${styles['accordion-ctm']} accordion`} id="accordionFourExample">
                                <div className={`${styles['accordionitem-ctm']} accordion-item`}>
                                    <h2 className={`${styles['accordionheader-ctm']} accordion-header`} id="headingFour">
                                        <button className={`${styles['accordionbutton-ctm']} accordion-button ${activeIndex === 4 ? '' : 'collapsed'}`} type="button" onClick={() => toggle(4)}>
                                            Current City
                                        </button>
                                    </h2>
                                    <div className={`${styles['accordioncollapse-ctm']} accordion-collapse ${activeIndex === 4 ? 'show' : ''}`} aria-labelledby="headingFour" data-bs-parent="#accordionFourExample">
                                        <div className={`${styles['accordionbody-ctm']} accordion-body`}>
                                            <Multiselect
                                                placeholder='Search your city'
                                                style={{
                                                    optionContainer:
                                                        state.city.options.length > 0 ? { display: 'block' } : { display: 'none' }
                                                }}
                                                options={state.city.options}
                                                onSelect={(selectedValue) => {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        ['city']: {
                                                            ...prevState['city'],
                                                            value: selectedValue,
                                                        }
                                                    }));

                                                }}

                                                onSearch={(value) => {
                                                    searchlocations(value).then(res => {
                                                        if (res.status) {
                                                            setOptions('city', res.result)
                                                        }
                                                    })
                                                }
                                                }
                                                selectedValues={state.city.value}
                                                displayValue={"location"}
                                                name={state.city.name}
                                                id="presentCity"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group mb-2">
                            <div className={`${styles['accordion-ctm']} accordion`} id="accordionFourExample">
                                <div className={`${styles['accordionitem-ctm']} accordion-item`}>
                                    <h2 className={`${styles['accordionheader-ctm']} accordion-header`} id="headingFour">
                                        <button className={`${styles['accordionbutton-ctm']} accordion-button ${activeIndex === 5 ? '' : 'collapsed'}`} type="button" onClick={() => toggle(5)}>
                                            Salary Range
                                        </button>
                                    </h2>
                                    <div className={`${styles['accordioncollapse-ctm']} accordion-collapse ${activeIndex === 5 ? 'show' : ''}`} aria-labelledby="headingFour" data-bs-parent="#accordionFourExample">
                                        <div className={`${styles['accordionbody-ctm']} accordion-body`}>
                                            {[
                                                { label: '1 - 5 Lacs', range: [1, 5] },
                                                { label: '5 - 10 Lacs', range: [5, 10] },
                                                { label: '10 - 15 Lacs', range: [10, 15] },
                                                { label: '20+ Lacs', range: [20, Infinity] },
                                                { label: '30+ Lacs', range: [30, Infinity] }
                                            ].map((salaryRange, index) => (
                                                <div key={index} className='form-check d-flex align-items-center'>
                                                    <input
                                                        className='form-check-input'
                                                        type='checkbox'
                                                        id={`salaryRange-${index}`}
                                                        checked={state.salary.value.some(
                                                            (item) => item[0] === salaryRange.range[0] && item[1] === salaryRange.range[1]
                                                        )}
                                                        onChange={() => handleSalaryCheckboxChange(salaryRange.range)}
                                                    />
                                                    <label className={`${styles['formcheckct-label']} form-check-label ps-2`} htmlFor={`salaryRange-${index}`}>
                                                        {salaryRange.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group mb-2">
                            <div className={`${styles['accordion-ctm']} accordion`} id="accordionFourExample">
                                <div className={`${styles['accordionitem-ctm']} accordion-item`}>
                                    <h2 className={`${styles['accordionheader-ctm']} accordion-header`} id="headingFour">
                                        <button className={`${styles['accordionbutton-ctm']} accordion-button ${activeIndex === 6 ? '' : 'collapsed'}`} type="button" onClick={() => toggle(6)}>
                                            Age
                                        </button>
                                    </h2>
                                    <div
                                        className={`${styles['accordioncollapse-ctm']} accordion-collapse ${activeIndex === 6 ? 'show' : ''}`}
                                        aria-labelledby="headingFour"
                                        data-bs-parent="#accordionFourExample"
                                    >
                                        <div className={`${styles['accordionbody-ctm']} accordion-body`}>
                                            {[
                                                { label: '18-25 Years', range: [18, 25] },
                                                { label: '25-30 Years', range: [25, 30] },
                                                { label: '30-40 Years', range: [30, 40] },
                                                { label: '40-50 Years', range: [40, 50] },
                                                { label: '50+ Years', range: [50, Infinity] }
                                            ].map((ageGroup, index) => (
                                                <div key={index} className='form-check d-flex align-items-center'>
                                                    <input
                                                        className='form-check-input'
                                                        type='checkbox'
                                                        id={`ageRange-${index}`}
                                                        checked={state.age.value.some(
                                                            (item) => item[0] === ageGroup.range[0] && item[1] === ageGroup.range[1]
                                                        )}
                                                        onChange={() => handleAgeCheckboxChange(ageGroup.range)}
                                                    />
                                                    <label
                                                        className={`${styles['formcheckct-label']} form-check-label ps-2 mt-1`}
                                                        htmlFor={`ageRange-${index}`}
                                                    >
                                                        {ageGroup.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div>
                            <button onClick={() => {
                                onSubmit()
                            }} className={`${styles['search-btn']} btn`}>Search Profile</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Index